import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import css from './PurchaseSelect.module.scss';

interface Props extends React.HTMLProps<HTMLSelectElement> {
  className?: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  selected: boolean;
}

const PurchaseSelect = ({
  className,
  children,
  intl,
  name,
  value,
  onChange,
  selected,
}: Props & InjectedIntlProps) => {
  const classes = classNames(
    css.PurchaseSelect,
    { [css.isSelected]: selected },
    className,
  );

  return (
    <select className={classes} name={name} value={value} onChange={onChange}>
      <option value={''} className={css.PurchaseSelect__Placeholder}>
        {intl.formatMessage({ id: 'purchases.purchaseSelect.please' })}
      </option>
      {children}
    </select>
  );
};

export default injectIntl(PurchaseSelect);
